import {useEffect} from "react";
import {authStore} from "../../features/auth/data";
import store from "../../redux/store";
import {eventsBroadcastChannel} from "../../utils/eventsBroadcastChannel";

/**
 * Подключает глобальную подписку на межвкладочные события сессии.
 *
 * Вызывать один раз в корне приложения ({@link App}).
 * `impersonate` / `impersonateEnd` — reload на других вкладках; на инициаторе — refresh Redux в localHandlers.
 * `logout` на инициаторе — сброс Redux, на остальных — reload.
 */
export const useCrossTabEvents = () => {
  useEffect(() => {
    const unsubscribe = eventsBroadcastChannel.listen();

    const onPageShow = (event: PageTransitionEvent) => {
      if (!event.persisted) {
        return;
      }

      store.dispatch(authStore.actions.resetNavigationLoading());
    };

    globalThis.addEventListener("pageshow", onPageShow);

    return () => {
      unsubscribe();
      globalThis.removeEventListener("pageshow", onPageShow);
    };
  }, []);
};
